/* eslint-disable max-len */
import React from "react";

interface SVGRProps {
    title?: string;
    titleId?: string;
}

const Upload = ({
    title = "upload a file",
    titleId = "tm-upload",
    ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 23"
        aria-hidden={!title}
        role={title ? "img" : ""}
        aria-label={title}
        height="1em"
        width="1em"
        fill="none"
    >
        <title id={titleId}>{title}</title>
        <path
            d="M18.752 8.5L12.001 1.75L5.25195 8.5H9.00095V15.25C9.00095 15.4489 9.07997 15.6397 9.22062 15.7803C9.36128 15.921 9.55204 16 9.75095 16H14.251C14.4499 16 14.6406 15.921 14.7813 15.7803C14.9219 15.6397 15.001 15.4489 15.001 15.25V8.5H18.752Z"
            stroke="#0A66C2"
            strokeWidth="1.995"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M23.252 17.5V20.5C23.252 20.8978 23.0939 21.2794 22.8126 21.5607C22.5313 21.842 22.1498 22 21.752 22H2.25195C1.85413 22 1.4726 21.842 1.19129 21.5607C0.909988 21.2794 0.751953 20.8978 0.751953 20.5V17.5"
            stroke="#0A66C2"
            strokeWidth="1.995"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Upload;
